// Prod has two working hostnames right now — the original Firebase default
// and the branded custom domain connected in Oct 2026 — but every link we
// generate for sharing (invite code, exam code) should always point at the
// branded one regardless of which an admin happens to be browsing from. Dev
// has no custom domain of its own, so it keeps sharing whatever origin it's
// actually running on.
const BRANDED_DOMAIN = 'https://skillassess.radtar.com'
const PROD_HOSTNAMES = ['radtar-skillassess.web.app', 'skillassess.radtar.com']

export function shareOrigin() {
  return PROD_HOSTNAMES.includes(window.location.hostname) ? BRANDED_DOMAIN : window.location.origin
}
